import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { SimpleTextArea } from "../SimpleTextArea/SimpleTextArea";
import { DataPicker } from "../DataPicker/DataPicker";
import { useDelayAction, useActionsDelayed } from "../../hooks/useCrm";
import { Label } from "../InputField/inputFieldStyle";
import Typogaphy from "../../components/Typography/Typography";
import Converter from "persian-date-converter";
import Loading from "../Loadings/LoadingTable";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";

const initvalue = {
  IdActivityCrm: null,
  DescriptionDelayCrm: "",
  IdS0alesOpportunities: null,
  DateDelayCrm: "",
};
export const DelayActionModal = ({
  show,
  handleClose,
  userdata,
  activityId,
}) => {
  const [form, setForm] = useState(initvalue);
  const [button] = useState(false);
  const { mutateAsync: DelayAction, isLoading: DelayActionLoading } =
    useDelayAction();
  const { data: delayedActions } = useActionsDelayed({
    IdActivityCrm: form.IdActivityCrm,
  });

  const _date = new Converter();

  const actionsDelayed = delayedActions?.data?.delay_crm_activities;

  useEffect(() => {
    setForm({
      ...form,
      IdActivityCrm: activityId,
      IdS0alesOpportunities:
        userdata?.sales_opportunities[0].IdS0alesOpportunities,
    });
  }, [userdata, activityId]);

  const setDateFunction = (date) => {
    const finalDate = date?.year + "-" + date?.month + "-" + date?.day;
    setForm({ ...form, DateDelayCrm: finalDate });
  };
  const handleDelayAction = async (delayAction) => {
    await DelayAction(delayAction);
  };
  return (
    <BootstrapModal
      modaltitle="به تاخیر انداختن فعالیت"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <SimpleTextArea
            cols="10"
            rows="3"
            placeholder="دلیل به تاخیر انداختن"
            label={"دلیل به تاخیر انداختن"}
            onChange={(e) =>
              setForm({ ...form, DescriptionDelayCrm: e.target.value })
            }
          />
        </div>
        <div className="col-lg-12">
          <DataPicker
            label="تاریخ به تاخیر انداختن"
            onChange={(event) => setDateFunction(event)}
            className="form-control"
          />
        </div>
        <div className="col-12">
          <Label>تاریخچه به تاخیر انداختن</Label>
          <div className="delayed">
            {/* {actionsDelayed?.length ? (
              <>
                {actionsDelayed?.map((action) => (
                  <Typogaphy>
                    توسط {action.FirstName} {action.LastName} تا تاریخ{" "}
                  </Typogaphy>
                ))}
              </>
            ) : (
              <Typogaphy className="text-center">تاریخچه خالی است</Typogaphy>
            )} */}
            {!DelayActionLoading ? (
              <>
                {actionsDelayed?.map((action) => {
                  const createDate = action.DateDelayCrm;
                  var year = createDate.slice(0, 4);
                  var month = createDate.slice(5, 7);
                  var day = createDate.slice(8, 10);
                  var date = year + "-" + month + "-" + day;
                  var dateWrapper = _date.convert(date, "fa");
                  return (
                    <>
                      <div className="d-flex mt-2 mb-2 text-[12px] flex-wrap">
                        توسط{" "}
                        <Typogaphy>
                          {action.FirstName} {action.LastName}
                        </Typogaphy>
                        <Typogaphy>
                          در تاریخ {MiladiToShamsi(action?.created_at)}
                        </Typogaphy>{" "}
                        تا تاریخ
                        <Typogaphy>{dateWrapper}</Typogaphy>به علت{" "}
                        {action?.DescriptionDelayCrm} به تاخیر افتاد
                      </div>
                    </>
                  );
                })}
              </>
            ) : (
              <Loading />
            )}
          </div>
        </div>
        <div className="col-12">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleDelayAction(form);
              handleClose();
            }}
          >
            تایید
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
